import { Show, createMemo, createSignal } from 'solid-js';
import type { ProjectManifest } from '../types/project';
import { PixelIcon } from './PixelIcon';

interface ProjectIconProps {
  project: ProjectManifest;
  size?: number;
}

function resolveIconUrl(project: ProjectManifest): string | undefined {
  if (!project.media?.icon || !project.runtimeUrl) return undefined;

  try {
    return new URL(project.media.icon, project.runtimeUrl).toString();
  } catch {
    return undefined;
  }
}

export function ProjectIcon(props: ProjectIconProps) {
  const [failed, setFailed] = createSignal(false);
  const size = () => props.size ?? 32;
  const iconUrl = createMemo(() => resolveIconUrl(props.project));
  const fallback = () => (props.project.slug === 'raytracer' ? 'raytracer' : 'project');

  return (
    <Show
      when={iconUrl() && !failed() ? iconUrl() : undefined}
      fallback={<PixelIcon name={fallback()} size={size()} />}
    >
      {(url) => (
        <img
          class="project-pixel-icon"
          src={url()}
          width={size()}
          height={size()}
          alt=""
          aria-hidden="true"
          draggable={false}
          onError={() => setFailed(true)}
        />
      )}
    </Show>
  );
}
